import { makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import clsx from "clsx";
import React from "react";

import { fontFamilies } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 16,
    borderRadius: 8,
    minHeight: 54,
    cursor: "pointer",
    position: "relative",
    backgroundColor: theme.palette.semantic["surface/base"],
    boxShadow: "inset 0 0 0 1.5px transparent",
    color: theme.palette.text.primary,
    "&:focus-within": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    [theme.breakpoints.up("md")]: { minHeight: 56 },
  },
  selected: {
    backgroundColor: theme.palette.semantic["state/selected-bg"],
    boxShadow: `inset 0 0 0 1.5px ${theme.palette.primary.main}`,
  },
  disabled: { color: theme.palette.text.disabled, cursor: "default" },
  input: { position: "absolute", width: 1, height: 1, opacity: 0 },
  label: { flex: 1, fontSize: 14, lineHeight: 1.5, [theme.breakpoints.up("md")]: { fontSize: 16 } },
  circle: {
    width: 22,
    height: 22,
    flexShrink: 0,
    borderRadius: "50%",
    border: `1.5px solid ${theme.palette.semantic["border/strong"]}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: fontFamilies.number,
    fontSize: 12,
    fontWeight: 600,
  },
  checked: {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  check: { fontSize: 16 },
}));

export const DiagnosisChoiceRow: React.FC<{
  label: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  type?: "checkbox" | "radio";
  name?: string;
  rank?: number;
  onChange: () => void;
}> = ({ label, value, checked, disabled, type = "checkbox", name, rank, onChange }) => {
  const classes = useStyles();
  const indicator = (
    <span aria-hidden="true" className={clsx(classes.circle, checked && classes.checked)}>
      {checked && (rank ? rank : <CheckIcon className={classes.check} />)}
    </span>
  );
  return (
    <label className={clsx(classes.row, checked && classes.selected, disabled && classes.disabled)}>
      <input
        className={classes.input}
        type={type}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      {rank !== undefined && indicator}
      <span className={classes.label}>{label}</span>
      {rank === undefined && indicator}
    </label>
  );
};
